import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../assests/images/Logo.png';

function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    const toggleMenu = () => setIsMenuOpen((prev) => !prev);
    const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
            <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
                {/* Logo */}
                <Link to="/" className="flex items-center space-x-3">
                    <img src={Logo} className="h-10" alt="KAVIPRIYA ASSOCIATES Logo" />
                    <span className="self-center text-1xl font-bold whitespace-nowrap text-purple-800">KAVIPRIYA ASSOCIATES</span>
                </Link>
                {/* Hamburger */}
                <button
                    type="button"
                    className="inline-flex items-center p-2 w-10 h-10 justify-center text-purple-800 rounded-lg md:hidden hover:bg-purple-100 focus:outline-none focus:ring-2 focus:ring-purple-200"
                    aria-controls="navbar-default"
                    aria-expanded={isMenuOpen}
                    onClick={toggleMenu}
                >
                    <span className="sr-only">Open main menu</span>
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <line x1="4" y1="7" x2="20" y2="7" stroke="currentColor" strokeWidth="2" />
                        <line x1="4" y1="12" x2="20" y2="12" stroke="currentColor" strokeWidth="2" />
                        <line x1="4" y1="17" x2="20" y2="17" stroke="currentColor" strokeWidth="2" />
                    </svg>
                </button>
                {/* Menu */}
                <div className={`${isMenuOpen ? 'block' : 'hidden'} w-full md:block md:w-auto`} id="navbar-default">
                    <ul className="font-medium flex flex-col md:flex-row md:space-x-8 p-4 md:p-0 mt-4 md:mt-0 border border-gray-100 md:border-0 rounded-lg bg-gray-50 md:bg-white text-purple-800 md:items-center">
                        <li>
                            <Link
                                to="/"
                                className="relative block py-2 px-3 rounded-md md:p-0 text-purple-800 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-0.5 after:bg-purple-700 after:transition-all after:duration-300 hover:after:w-full hover:text-purple-900 focus:after:w-0"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/about"
                                className="relative block py-2 px-3 rounded-md md:p-0 text-purple-800 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-0.5 after:bg-purple-700 after:transition-all after:duration-300 hover:after:w-full hover:text-purple-900 focus:after:w-0"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                About Us
                            </Link>
                        </li>
                        {/* Dropdown */}
                        <li className="relative" ref={dropdownRef}>
                            <button
                                onClick={() => {
                                    navigate('/services');
                                    setIsDropdownOpen(true);
                                    setIsMenuOpen(false);
                                }}
                                className="relative w-full md:w-auto flex items-center justify-between py-2 px-3 rounded-md md:p-0 text-purple-800 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-0.5 after:bg-purple-700 after:transition-all after:duration-300 hover:after:w-full hover:text-purple-900 focus:after:w-0"
                            >
                                Our Services
                                <svg className="w-3 h-3 ml-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 10 6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M1 1l4 4 4-4" />
                                </svg>
                            </button>
                            {/* Dropdown menu */}
                            <div className={`absolute left-0 md:left-auto md:right-0 w-64 mt-2 bg-white rounded-md shadow-md z-50 transition-all duration-300 origin-top transform ${isDropdownOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0 pointer-events-none'}`}>
                                <ul className="text-sm text-purple-800 py-2">
                                    {[ 
                                        { id: 1, name: 'Start-Ups & MSME Subsidy' },
                                        { id: 2, name: 'Goods and Service Tax' },
                                        { id: 3, name: 'Income Tax – Salary, Company, TDS etc.' },
                                        { id: 4, name: 'Book Keeping' },
                                        { id: 5, name: 'Foreign Trade Management – DGFT' },
                                        { id: 6, name: 'Customs Clearance & MOOWR' },
                                        { id: 7, name: 'Health, Wealth and Marine Insurance' },
                                        { id: 8, name: 'Other Statutory Requirements' }
                                    ].map(service => (
                                        <li key={service.id}>
                                            <Link
                                                to={`/services/${service.id}`}
                                                className="block px-4 py-2 hover:bg-purple-100"
                                                onClick={() => { setIsMenuOpen(false); setIsDropdownOpen(false); }}
                                            >
                                                {service.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </li>
                        <li>
                            <Link
                                to="/contact"
                                className="relative block py-2 px-3 rounded-md md:p-0 text-purple-800 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-0.5 after:bg-purple-700 after:transition-all after:duration-300 hover:after:w-full hover:text-purple-900 focus:after:w-0"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Contact
                            </Link>
                        </li>
                        {/* Contact Info */}
                        <li className="mt-2 md:mt-0 md:ml-6 flex flex-col md:flex-row md:items-center text-sm text-purple-800 px-4 py-2">
                            <a
                                href="https://wa.me/919994426564"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:underline mb-2 md:mb-0 md:mr-4"
                            >
                                📞 +91 99944 26564
                            </a>
                            <a
                                href="mailto:info@kavipriyaassociates.com"
                                className="hover:underline"
                            >
                                ✉️ info@kavipriyaassociates.com
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
